<template>
  <BModal
    id="email-confirmation-required"
    centered
    hide-footer
    title="E-mail não confirmado"
  >
    <p class="email-confirmation-modal__text">
      Antes de agendar uma consulta com um médico, você precisa confirmar seu
      e-mail antes.
    </p>
    <BaseButton
      variant="link"
      class="email-confirmation-modal__resend"
      :disabled="isResending"
      @click="handleResendEmail"
    >
      {{ isResending ? "Enviando..." : "Reenviar e-mail" }}
    </BaseButton>
  </BModal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "EmailConfirmationRequiredModal",
  data() {
    return {
      isResending: false
    };
  },
  methods: {
    ...mapActions("user", ["resendEmailConfirmation"]),
    async handleResendEmail() {
      this.isResending = true;
      try {
        await this.resendEmailConfirmation();
        this.$toast.success("E-mail de confirmação reenviado com sucesso.");
      } catch (err) {
        const message =
          err?.response?.data?.error ||
          "Não foi possível reenviar o e-mail. Tente novamente.";
        this.$toast.error(message);
      } finally {
        this.isResending = false;
      }
    }
  }
};
</script>

<style scoped>
.email-confirmation-modal__text {
  margin-bottom: var(--space-3);
}

.email-confirmation-modal__resend {
  font-size: var(--font-size-lg);
  font-weight: var(--fw-semibold);
  border: 1px solid currentColor;
  border-radius: var(--radius-sm);
  padding: var(--space-2) var(--space-3);
  transition: background-color 0.15s ease;
}

.email-confirmation-modal__resend:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.06);
}
</style>
